// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c9d0a0bf","732":"b2d9a846","977":"a58e91a4"}[chunkId] + ".chunk.js";
};